window.addEventListener('DOMContentLoaded', (event) => {
    const initBootstrapScript = () => {
        if (!document.querySelector('#bootstrap-js')) {
            const script = document.createElement('script')
            script.setAttribute('id', 'bootstrap-js')
            script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.min.js')
            script.setAttribute('integrity', 'sha384-QJHtvGhmr9XOIpI6YVutG+2QOK9T+ZnN4kzFN1RtK3zEFEIsxhlmWl5/YESvpZ13')
            script.setAttribute('crossorigin', 'anonymous')
            document.head.appendChild(script)
        }
    }
    initBootstrapScript()

    // Open the cart drawer by URL if contains '#cart'
    if (window.location.hash.includes('#cart')) {
        const checkBootstrap = () => {
            if (typeof bootstrap !== 'undefined') {
                const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#cart-drawer')
                offcanvas.show()
            } else {
                setTimeout(checkBootstrap, 100)
            }
        }
        
        setTimeout(checkBootstrap, 250)
    }

    // Load cart drawer on ajax add/update
    window.loadEgCartDrawer = async () => {
        try {
            const $cartDrawer = document.querySelector('#cart-drawer')
            if (!$cartDrawer) return;

            const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance($cartDrawer)
            bsOffcanvas.show()

            const $form = $cartDrawer.querySelector('form')
            $form.style.opacity = '.2'

            const response = await fetch('/')
            const data = await response.text()

            const parser = new DOMParser()
            const newDocument = parser.parseFromString(data, 'text/html')

            $form.replaceWith(newDocument.querySelector('#cart-drawer form'))

            document.querySelector('#cart-icon-bubble')
                ?.replaceWith(newDocument.querySelector('#cart-icon-bubble'))

            initCartDrawerQuantity()
            initCartUpsells()
        } catch (error) {
            console.error('Error al cargar el carrito:', error)
        }
    }

    // Handle quantity
    const initCartDrawerQuantity = () => {
        document.querySelectorAll('#cart-drawer .quantity__input').forEach(($input) => {
            $input.addEventListener('change', async (e) => {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: $input.dataset.index,
                        quantity: Number($input.value)
                    })
                })
                loadEgCartDrawer()
            })
        })
    }
    initCartDrawerQuantity()

    // Cart Upsells 
    const initCartUpsells = async () => {
        document.querySelectorAll('#eg-cart-drawer-upsells-list button').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                e.preventDefault()
                try {
                    btn.querySelector('span').classList.add('hidden')
                    btn.querySelector('.loading-overlay__spinner').classList.remove('hidden')

                    const variantId = btn.closest('.eg-cart-drawer-upsells-list-item').querySelector('select[name="id"]').value

                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            items: [{
                                id: Number(variantId),
                                quantity: 1
                            }]
                        })
                    })

                    const data = await response.json()
                    
                    await loadEgCartDrawer()
                } catch (error) {
                    console.error('Error al agregar producto:', error)
                } finally {
                    btn.querySelector('span').classList.remove('hidden')
                    btn.querySelector('.loading-overlay__spinner').classList.add('hidden')
                }
            })
        }) 
    }
    initCartUpsells()

})

async function clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (response.ok) {
        await loadEgCartDrawer();
      } else {
        console.error('Error clearing cart');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }


  document.addEventListener('click', function(e) {
    if (e.target.closest('.remove-button')) {
      e.preventDefault();
      const button = e.target.closest('.remove-button');
      const itemId = button.dataset.itemId;
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemId,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(cart => {
        loadEgCartDrawer();
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  });
